<template>
  <MainTopHeader />
  <router-view />
  <footer id="footer" class="footer">
    <!-- <div class="footer_container">
		<div class="footer_wrap"> -->
    <h3 class="hide">하단메뉴</h3>
    <ul class="foot_menu">
      <li class="fisrt">
        <a id="eeeee" href="/">이용약관</a>
      </li>
      <li>
        <strong><a href="/">개인정보 처리방침</a></strong>
      </li>
      <li>
        <strong><a href="/">인쇄복권당첨금지급기준</a></strong>
      </li>

      <li>
        <a href="/">불법사행행위신고센터</a>
      </li>
      <li>
        <a href="/">수탁사업자소개</a>
      </li>
      <li>
        <a href="/">ENGLISH</a>
      </li>
    </ul>
    <div class="foot_inner">
      <div class="foot_txt_wrap">
        <div class="logo">
          <div class="inner">
            <strong class="dh">동행복권</strong>
            <a href="/" class="btn_foot" title="새창 열림">사업자정보확인</a>
          </div>
        </div>
        <div class="foot_txt1">
          <p>
            수탁사업자 (주)동행복권 <span class="ml15">주소 : 06719 서울 서초구 남부순환로 2423 한원빌딩 4층</span>
          </p>
          <p>
            대표자 : 홍덕기 <span class="ml15">사업자등록번호 866-87-00833</span>
            <span class="ml15"> 통신판매사업자번호 : 제2018 - 서울서초 - 2075호</span>
            <!-- <span class="ml15"><a href="javascript:goFacPop()" class="btn_foot">사업자정보확인 &gt;</a></span> -->
          </p>
        </div>
        <div class="foot_txt1">
          <br />
          <p>본 홈페이지는 게시된 이메일 주소가 자동 수집되는 것을 거부하며, 이를 위반시 정보통신망법에 의해 처벌됨을 유념하여 주시길 바랍니다.</p>
          <p>19세 미만일 경우 「복권 및 복권기금법」에 따라 복권을 구매할 수 없습니다.</p>
        </div>
        <div class="foot_txt2">
          <p>본 사이트는 Internet Explorer 11, Edge, Chrome, Safari 브라우저에 최적화되어 있습니다.</p>
        </div>
        <div class="foot_txt2">
          <p>Copyright (c) 2018 복권위원회&amp;동행복권. All rights reserved</p>
        </div>
      </div>

      <div class="group_inner">
        <div class="foot_txt_wrap">
          <div class="foot_integrated">
            <div style="text-align: left">
              <img src="~@/assets/images/dhb/certified_mark1.png" alt="certified_mark1" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- </div>
	</div> -->
  </footer>
  <aside id="asideQuick" class="quic_aside" style="right: 0px">
    <a href="/" class="toggle">퀵메뉴열기</a>
    <div class="inner">
      <ul class="prog">
        <li class="p0">
          <a href="/">미수령<br />당첨금</a>
        </li>
        <li class="p1">
          <a href="/">나의복권<br />건전지수</a>
        </li>
        <li class="p2">
          <a href="/">건전구매<br />캠페인</a>
        </li>
        <li class="p3">
          <a href="/">건전구매<br />서약</a>
        </li>
        <li class="p4">
          <a href="/">자기관리<br />프로그램</a>
        </li>
        <li class="p5">
          <a href="/" title="새창 열림">동행<br />클린센터</a>
        </li>
        <li class="p6">
          <a href="/">동행<br />히어로</a>
        </li>
      </ul>
    </div>
    <div class="top"><a href="/">위로가기</a></div>
  </aside>
</template>

<script>
import MainTopHeader from '@/components/Header/MainTopHeader';

export default {
  components: {
    MainTopHeader,
  },
  data: function () {
    return {
      loaded: false,
    };
  },
  mounted() {
    document.body.classList.remove('auth');
    // const loading = this.$loading({
    //   lock: true,
    //   text: 'Loading',
    //   background: 'rgba(0, 0, 0, 0.7)',
    // });
    setTimeout(() => {
      this.loaded = true;
      // loading.close();
      // this.$alert('Are you sure to close this dialog?', {
      //   customClass: 'messda',
      //   customStyle: 'margin-top:0',
      // });
    }, 1000);
  },
  methods: {
    getContainerClass() {
      return {
        'large-container': this.$route.name === 'BetHistory' || this.$route.name === 'CsWrite',
        'partner-container': this.$route.name && this.$route.name.indexOf('Partner') > -1,
      };
    },
  },
};
</script>
<style lang="scss">
body {
  background: #fff !important;
}
</style>
